import { Component, OnDestroy } from '@angular/core';
import { LoaderService } from '../../services/loader.service';
import { Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  imports: [CommonModule]
})
export class LoaderComponent implements OnDestroy {

  public showLoader = false;
  public isDelayed = false;
  private loaderSubscription: Subscription;
  //public spinnerDelayTimeout: NodeJS.Timer;
  private spinnerDelayTimeout: ReturnType<typeof setTimeout>;


  constructor(
    private loaderService: LoaderService
  ) {
    this.loaderSubscription = this.loaderService.loaderObservable.subscribe(config => {
      if (!this.showLoader && config.isLoading && config.timeout > -1) {
        this.spinnerDelayTimeout = setTimeout(() => { this.applySpinnerDelay(); }, config.timeout);
      } else if (this.showLoader && !config.isLoading && this.spinnerDelayTimeout) {
        clearTimeout(this.spinnerDelayTimeout);
      }

      this.showLoader = config.isLoading;
    });
  }

  private applySpinnerDelay(): void {
    this.isDelayed = true;
  }

  public ngOnDestroy(): void {
    this.loaderSubscription.unsubscribe();
  }

}
